export { FacilitiesVersion as Facilities } from './FacilitiesVersion';
